// スムーススクロール用

document.addEventListener("DOMContentLoaded", function () {
	const header = document.querySelector("header");
	const headerHeight = header ? header.offsetHeight + 20 : 20;

	function smoothScroll(target) {
		const element = document.querySelector(target);
		if (!element) return;

		const targetPosition = element.getBoundingClientRect().top + window.scrollY - headerHeight;
		window.scrollTo({ top: targetPosition, behavior: "smooth" });
	}

	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
		anchor.addEventListener("click", function (e) {
			e.preventDefault();
			const targetId = this.getAttribute("href");
			smoothScroll(targetId);
		});
	});

	if (window.location.hash) {
		setTimeout(() => {
			smoothScroll(window.location.hash);
		}, 200);
	}
});
